import isTDocument from '@modules/documents/helpers/isTDocument.helper';
import { TDocument } from '@modules/documents';
import { TFile } from '@modules/files';
import isTFile from '@modules/files/helpers/isTFile.helper';
import { TInlineBlock } from '@modules/inlineBlocks';
import { TItemVersion } from '../types/items.types';

const getItemVersions = (item: TDocument | TFile | TInlineBlock) =>
  isTFile(item)
    ? item.versions.map((version) => ({ type: item.type, item, version }) satisfies TItemVersion)
    : isTDocument(item)
      ? item.versions.map((version) => ({ type: item.type, item, version }) satisfies TItemVersion)
      : item.versions.map((version) => ({ type: item.type, item, version }) satisfies TItemVersion);

export default getItemVersions;
